import { OperationTypeNode } from 'graphql';
import { matchPath } from 'react-router-dom';

import { ERRORS_403, ERRORS_404 } from '@/config/GraphqlErorrCodes.config';

export class RedirectionHelpers {
  static shouldRedirectTo403Page(operationType: OperationTypeNode, apiErrorCode: string | undefined) {
    const currentUrlPath = window.location.pathname;

    const isNotAuthorizedPage = matchPath(currentUrlPath, {
      path: '/not-authorized',
      exact: true,
    });

    const shouldRedirectTo403Page = typeof apiErrorCode === 'string'
      && ERRORS_403.includes(apiErrorCode)
      && !isNotAuthorizedPage
      && operationType === OperationTypeNode.QUERY;

    return shouldRedirectTo403Page;
  }

  static shouldRedirectTo404Page(operationType: OperationTypeNode, apiErrorCode: string | undefined) {
    const currentUrlPath = window.location.pathname;

    const is404Page = matchPath(currentUrlPath, {
      path: '/not-found',
      exact: true,
    });

    const urlCanLead404PageOnSpecificError = [
      '/contracts-bc/:contractId/add-contract-line',
      '/contracts-bc/:contractId',
    ];

    const isPossibleToRedirectFromThisPath = urlCanLead404PageOnSpecificError.find((path) => {
      return matchPath(currentUrlPath, {
        path: path,
        exact: true,
      });
    });

    const shouldRedirectTo404Page = typeof apiErrorCode === 'string'
      && ERRORS_404.includes(apiErrorCode)
      && !is404Page
      && operationType === OperationTypeNode.QUERY
      && isPossibleToRedirectFromThisPath;

    return shouldRedirectTo404Page;
  }
}